// src/config/api.config.ts
export interface ApiConfig {
  baseUrl: string
  endpoints: {
    cameras: string
    cameraModels: string
    clients: string
    users: string
    anprEvents: string
    ahcrEvents: string
    health: string
    alarms: string
    capture: string
    auth: {
      login: string
      refresh: string
    }
  }
  timeout: number
}
const baseApiUrl: string = process.env.REACT_APP_API_BASE_URL ?? ''

const apiConfig: ApiConfig = {
  baseUrl: baseApiUrl,
  endpoints: {
    cameras: '/camera',
    cameraModels: '/CameraModel',
    clients: '/client',
    users: '/user',
    anprEvents: '/ANPREvent',
    ahcrEvents: '/AHCREvent',
    health: '/Health',
    alarms: '/Alarm',
    capture: '/capture',
    auth: {
      login: '/auth/login',
      refresh: '/auth/refresh',
    },
  },
  timeout: 30000,
}

export default apiConfig
